import React, { useEffect, useState } from "react"
import Select from "react-select"
import CustomFieldService from "../state/custom-fields/CustomFieldService"
import { isError } from "../state/helpers/Error"

type OwnProps = {
    name?: string,
    editable: boolean,
    onSelectChange: (selectedOptions: object[]) => void,
    selectedCustomFieldIds: string[],
    isAvailableFrom?: string[],
    supportedFieldTypes?: string[],
    placeholder?: string,
}

const CustomFieldsSelectComponent = (props: OwnProps) => {
    const [customFieldDefinitionOptions, setCustomFieldDefinitionOptions] = useState([])
    const [selectedCustomFieldOptions, setSelectedCustomFieldOptions] = useState([])
    const [hasFetched, setHasFetched] = useState<boolean>(false)

    const fetchCustomFieldDefinitions = () => {
        const res = CustomFieldService.getAll()
        res.then(r => {
            setHasFetched(true)
            if (!isError(r)) {
                const availableFields = r.filter(cf => cf.isAvailable(props.isAvailableFrom ?? []))
                const supportedFields = availableFields.filter(cf => props.supportedFieldTypes ?
                    props.supportedFieldTypes.includes(cf.getFieldType()) : true)
                const options = supportedFields.map(customFieldDefinition => {
                    return {
                        value: customFieldDefinition.getId(),
                        label: `${customFieldDefinition.getName()}`,
                        customFieldDefinition: customFieldDefinition,
                    }
                })
                // @ts-ignore todo fix
                setCustomFieldDefinitionOptions(options)
                const selectedOptions = props.selectedCustomFieldIds.map(cfId => {
                    return options.find(cfOption => cfOption.value === cfId)
                }).filter(cf => cf)
                // @ts-ignore todo fix
                setSelectedCustomFieldOptions(selectedOptions)
            }
        })
    }

    useEffect(() => {
        if (!hasFetched) {
            fetchCustomFieldDefinitions()
        } else {
            const selectedOptions = props.selectedCustomFieldIds.map(cfId => {
                // @ts-ignore todo fix
                return customFieldDefinitionOptions.find(cfOption => cfOption.value === cfId)
            }).filter(cf => cf)
            // @ts-ignore todo fix
            setSelectedCustomFieldOptions(selectedOptions)
        }
    }, [props.selectedCustomFieldIds])

    return (
        <Select
            name={props.name}
            placeholder={props.placeholder || ""}
            value={selectedCustomFieldOptions}
            onChange={(selectedOptions) => {
                setSelectedCustomFieldOptions(selectedOptions)
                props.onSelectChange(selectedOptions)
            }}
            options={customFieldDefinitionOptions}
            clearable={props.editable}
            searchable={props.editable}
            disabled={!props.editable}
            multi={true}
        />
    )
}

export default CustomFieldsSelectComponent


// WEBPACK FOOTER //
// ./src/scheduling-page/CustomFieldsSelectComponent.tsx